import { Box, Grid, Typography } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, EnhancedCheckboxRHF, EnhancedRadioGroupRHF, LabelPosition, RHookFormDatePicker, RHookFormNumberField, RHookFormTextField, RHookFormTextFieldWithLabel, } from "@websential/cosmic-v20";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";

import { formatAmountCommaSeperator } from "../../../../common/Common";
import { useWatch } from "react-hook-form";

interface ITD1FormDataConstant {
    federalFormData: any
    employeeTD1FromId: any
    selectedTD1Employee: any
    selectedTD1EmployeeDataByIddetails: any
    existingRecordData?: any;
    formMethods: any
    id: any,
    onResetDeductionPanelClicked: () => void;
    onRefreshDeductionPanelClicked: () => void;
    td1FormSlug: any;
    canadaProvince: any;
}
export const TD1FormDataConstant: FC<
    ITD1FormDataConstant
> = ({ federalFormData, existingRecordData, employeeTD1FromId, selectedTD1Employee, selectedTD1EmployeeDataByIddetails, formMethods, id, onResetDeductionPanelClicked, onRefreshDeductionPanelClicked, td1FormSlug, canadaProvince }) => {



    const totalClaimAmountData = federalFormData && federalFormData.find((x: any) => x.heading === "TOTAL CLAIM AMOUNT")
    const updatedfederalFormDataWithoutTotalClaimAmount = federalFormData && federalFormData.filter((item: any) => item.heading !== "TOTAL CLAIM AMOUNT");


    const [totalClaimAmount, setTotalClaimAmount] = useState("0.00");
    useEffect(() => {
        if (selectedTD1EmployeeDataByIddetails) {
            setTotalClaimAmount(selectedTD1EmployeeDataByIddetails.totalClaimAmount)
        }
    }, [selectedTD1EmployeeDataByIddetails])

    const [checkboxFieldValueSelected, setCheckboxFieldValueSelected] = useState<any>([]);
    const [fieldclaimCodeAll, setFieldClaimCodeAll] = useState(false);
    const [totalDays, setTotalDays] = useState<number>(0);
    const [totalAmount, setTotalAmount] = useState<string>("0.00");

    const calculateTotalDaysAndAmount = (
        startDate: any,
        endDate: any,
        amountRate: any
    ): { days: number; amount: number } => {
        if (!startDate || !endDate || !amountRate) {
            return { days: 0, amount: 0 };
        }

        const start = new Date(startDate);
        const end = new Date(endDate);

        if (isNaN(start.getTime()) || isNaN(end.getTime()) || end < start) {
            return { days: 0, amount: 0 };
        }

        const miliSecondsPerDay = 1000 * 60 * 60 * 24;
        // inclusive of both start and end date (Sep 1 -> Sep 22 = 22 days)
        const days = Math.round((end.getTime() - start.getTime()) / miliSecondsPerDay) + 1;
        const amount = days * Number(amountRate);

        return { days, amount };
    };

    const dateFrom = useWatch({ control: formMethods.control, name: "dateFrom" });
    const dateTo = useWatch({ control: formMethods.control, name: "dateTo" });
    const amountForEachDay = useWatch({ control: formMethods.control, name: "amountForEachDay" });

    const lastChangedValue = useRef<string>("");

    const currentKey = `${dateFrom ?? ""}|${dateTo ?? ""}|${amountForEachDay ?? ""}`;

    if (currentKey !== lastChangedValue.current) {
        lastChangedValue.current = currentKey;

        const { days, amount } = calculateTotalDaysAndAmount(dateFrom, dateTo, amountForEachDay);
        const nextTotalAmount = amount ? formatAmountCommaSeperator(amount) : "0.00";

        // synchronously with the new values, so there's no flash/flicker
        setTotalDays(days);
        setTotalAmount(nextTotalAmount);
    }



    useEffect(() => {

        if (selectedTD1Employee === 'create-new') {
            updatedfederalFormDataWithoutTotalClaimAmount.forEach((item: any) => {
                if (item.indexForValue !== 1) {
                    formMethods.setValue(`tD1FieldId_${item.indexForValue}`, null);
                    formMethods.setValue(`checkbox-${item.indexForValue}`, false);
                }
            });
            setCheckboxFieldValueSelected([])
            setFieldClaimCodeAll(false)

            formMethods.setValue("dateFrom", null);
            formMethods.setValue("dateTo", null);
            formMethods.setValue("amountForEachDay", "");
            formMethods.setValue("prescribedZonesEmployee", false);
            formMethods.setValue("additionalTaxToBeDeducted", null);
        }
        // if (selectedTD1Employee === employeeTD1FromId) {
        //     setCheckboxFieldValueSelected([])
        //     setFieldClaimCodeAll(false)
        // }
    }, [selectedTD1Employee, employeeTD1FromId])

    const handleCheckBoxValue = (check: boolean, value: any, indexForValue: number) => {
        setCheckboxFieldValueSelected((prev: any[]) => {

            if (check) {
                formMethods.setValue(`tD1FieldId_${indexForValue}`, value);

                const prevData = prev.some(item => item.indexForValue === indexForValue);
                if (prevData) return prev;

                let valueToUse = value;

                if (existingRecordData) {
                    const existingItem = existingRecordData.find(
                        (x: any) => x.indexForValue === indexForValue
                    );

                    if (existingItem && existingItem.value !== null && existingItem.value !== 0) {
                        valueToUse = existingItem.value;
                    }
                }
                return [...(prev), { value: valueToUse, indexForValue }];
            } else {
                // formMethods.setValue(`tD1FieldId_${indexForValue}`, null);

                formMethods.setValue(`checkbox-${indexForValue}`, false);
                formMethods.setValue(`tD1FieldId_${indexForValue}`, 0);
                return prev.filter(item => item.indexForValue !== indexForValue);
            }
        });
    };

    const handleFieldSetClaimCodeAll = (check: boolean) => {
        setFieldClaimCodeAll(check)
        if (check) {
            updatedfederalFormDataWithoutTotalClaimAmount.forEach((item: any) => {
                if (item.indexForValue !== 1) {
                    formMethods.setValue(`tD1FieldId_${item.indexForValue}`, null);
                    formMethods.setValue(`checkbox-${item.indexForValue}`, false);
                }
            });
            setCheckboxFieldValueSelected([]);
        }
    }

    // useEffect(() => {
    //     if (id) {
    //         const matchedItems = updatedfederalFormDataWithoutTotalClaimAmount
    //             .filter((item: any) =>
    //                 item.indexForValue !== 1 &&
    //                 item.value !== null &&
    //                 item.templateValue !== null &&
    //                 item.value === item.templateValue
    //             )
    //             // .map((item: any) => ({
    //             //     value: item.templateValue,
    //             //     indexForValue: item.indexForValue
    //             // }));
    //             .map((item: any) => {
    //                 formMethods.setValue(`checkbox-${item.indexForValue}`, true); /// fix later to change this set claim all

    //                 return {
    //                     value: item.templateValue,
    //                     indexForValue: item.indexForValue
    //                 };
    //             });
    //         setCheckboxFieldValueSelected(matchedItems);
    //     }
    // }, [id]);

    useEffect(() => {
        if (!id) return;
        setCheckboxFieldValueSelected([]);
        updatedfederalFormDataWithoutTotalClaimAmount.forEach((item: any) => {
            formMethods.setValue(`checkbox-${item.indexForValue}`, false);
        });
        const matchedItems = updatedfederalFormDataWithoutTotalClaimAmount
            .filter((item: any) =>
                item.indexForValue !== 1 &&
                item.value !== null &&
                item.templateValue !== null &&
                item.value === item.templateValue
            )
            .map((item: any) => {
                formMethods.setValue(`checkbox-${item.indexForValue}`, true);
                return {
                    value: item.templateValue,
                    indexForValue: item.indexForValue
                };
            });

        setCheckboxFieldValueSelected(matchedItems);

        setFieldClaimCodeAll(selectedTD1EmployeeDataByIddetails?.setClaimCode === true);
        formMethods.setValue(
            "setClaimCode",
            selectedTD1EmployeeDataByIddetails?.setClaimCode === true
        );

    }, [id]);


    useEffect(() => {

        const firstItem =
            updatedfederalFormDataWithoutTotalClaimAmount.find(
                (item: any) => item.indexForValue === 1
            );

        if (
            !fieldclaimCodeAll &&
            firstItem &&
            (firstItem.value === null ||
                firstItem.value === undefined ||
                firstItem.value === 0) &&
            firstItem.templateValue !== null &&
            firstItem.templateValue !== undefined
        ) {
            formMethods.setValue(
                "tD1FieldId_1",
                // formatAmountCommaSeperator(firstItem.templateValue),
                firstItem.templateValue,
                {
                    shouldDirty: false,
                    shouldValidate: false,
                }
            );
            // formMethods.setValue(
            //     "tD1FieldId_12",
            //     // formatAmountCommaSeperator(firstItem.templateValue),
            //     firstItem.templateValue,
            //     {
            //         shouldDirty: false,
            //         shouldValidate: false,
            //     }
            // );
        }

    }, [fieldclaimCodeAll]);




    return (
        <>
            {updatedfederalFormDataWithoutTotalClaimAmount && (
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography
                        sx={{
                            fontSize: ".875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                            padding: "0rem 1rem",
                            marginBottom: "1rem",
                            fontStyle: "italic",

                        }}>

                        {/* Needs to be completed for new employees and for existing employees who want to increase the amount of tax deducted at source. If TD1 is not completed for an employee, the employer will deduct taxes after allowing for the basic personal amount only. If your TOTAL CLAIM AMOUNT is more than $ <span style={{
                            color: "red",
                            fontWeight: "bold"
                        }}>{`${updatedfederalFormDataWithoutTotalClaimAmount[0].value !== null ? formatAmountCommaSeperator(updatedfederalFormDataWithoutTotalClaimAmount[0].value) : "0.00"}`}</span>, also complete <span style={{
                            color: "#0091b3",
                            fontWeight: "bold"
                        }}>Provincial TD1 </span> Form */}

                        Complete this form if the employee have not previously provided a <span style={{
                            color: "#0091b3",
                            fontWeight: "bold"
                        }} >{`${selectedTD1EmployeeDataByIddetails && selectedTD1EmployeeDataByIddetails?.province?.name?.toUpperCase() ? selectedTD1EmployeeDataByIddetails && selectedTD1EmployeeDataByIddetails?.province?.name?.toUpperCase() : (td1FormSlug === 'federal' ? 'Federal' : canadaProvince?.find((provinceLabel: any) => provinceLabel.label.toLowerCase().replace(/\s+/g, '_') === td1FormSlug)?.label)} TD1`}</span> form to the employer or payer, or if there has been a change in the employee's entitlement to personal tax credits, and the employee is:
                        <br />
                        - working in <span style={{
                            color: "#0091b3",
                            fontWeight: "bold"
                        }}>{selectedTD1EmployeeDataByIddetails && selectedTD1EmployeeDataByIddetails?.province?.name.toUpperCase()}</span>
                        <br />
                        - a pensioner residing in <span style={{
                            color: "#0091b3",
                            fontWeight: "bold"
                        }}>{selectedTD1EmployeeDataByIddetails && selectedTD1EmployeeDataByIddetails?.province?.name.toUpperCase()}</span>

                    </Typography>
                </Grid>
            )}
            <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ marginBottom: "1.3rem" }}>
                <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}></Grid>
                <Grid size={{ xs: 9.66, sm: 9.66, md: 9.66, lg: 9.66, xl: 9.66 }}
                    sx={{
                        "& .MuiFormControlLabel-root": {
                            marginBottom: "0!important",
                            color: "rgba(0, 0, 0, 0.6)",
                        },
                        "& .MuiFormControlLabel-root .MuiTypography-root": {
                            fontSize: "0.875rem"
                        },
                        display: "flex", alignItems: "end"
                    }}
                >
                    <EnhancedCheckboxRHF
                        name={"setClaimCode"}
                        // checked={updatedfederalFormDataWithoutTotalClaimAmount[0].value === null  || fieldclaimCodeAll}
                        checked={fieldclaimCodeAll}
                        testId="setClaimCode"
                        checkboxLabel="Set CLAIM CODE to 0"
                        onSelectionChangeHandler={(check: boolean) => handleFieldSetClaimCodeAll(check)}
                    />
                </Grid>
                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }} sx={{
                    justifyContent: "end", display: "flex", "& .calenderWrapper ": {
                        marginBottom: "0!important",
                        minWidth: "178px!important"
                        // fontSize: ".875rem" 
                    }
                }}>
                    <RHookFormDatePicker
                        name="effectiveDate"
                        testId="TD1-date"
                        label="TD1 Date"
                        labelPosition={LabelPosition.Top}
                        format="M dd, yy"
                        labelColumns={4}
                        fieldColumns={8}
                    // required
                    />
                </Grid>
            </Grid>

            {updatedfederalFormDataWithoutTotalClaimAmount.map((item: any) => (


                <Grid
                    container
                    key={item.indexForValue}
                    sx={{
                        marginBottom: "1.5rem",
                    }}
                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                >
                    <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}>
                        <Box sx={{ display: "flex", alignItems: "start", marginRight: "1rem", marginTop: "0.2rem" }}>
                            <Typography fontWeight="bold" fontSize=".875rem">
                                {item.indexForValue}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 9.6, sm: 9.6, md: 9.6, lg: 9.6, xl: 9.6 }}>
                        <Box sx={{ flex: 1, flexWrap: "" }}>
                            <Typography
                                component="span"
                                sx={{
                                    fontWeight: "bold", fontSize: ".875rem",
                                }}
                            >
                                {`${item.heading} - `}

                            </Typography>
                            {/* {item.value !== null && item.value !== 0 && item.indexForValue !== 1 && ( */}
                            {(updatedfederalFormDataWithoutTotalClaimAmount.some((x: any) => x.templateValue !== undefined)
                                ? item.templateValue !== null && item.templateValue !== 0 && item.indexForValue !== 1
                                : item.value !== null && item.value !== 0 && item.indexForValue !== 1
                            ) && (
                                    <Typography

                                        component="span"
                                        sx={{
                                            "& .MuiFormControlLabel-root": {
                                                width: "10px !important",
                                                height: "10px",
                                                marginBottom: "0!important",
                                            },
                                            "& .MuiFormHelperText-root": {
                                                display: "none",
                                            },

                                            marginRight: ".5rem",
                                            pointerEvents: fieldclaimCodeAll ? "none" : "auto",

                                        }}

                                    >
                                        <EnhancedCheckboxRHF
                                            name={`checkbox-${item.indexForValue}`}
                                            // checked={checkboxFieldValueSelected === item.value}
                                            // checked={id && item.value !== null && item.value === item.templateValue !== null && item.templateValue ? true || checkboxFieldValueSelected.some((x: any) => x.indexForValue === item.indexForValue) : checkboxFieldValueSelected.some((x: any) => x.indexForValue === item.indexForValue)}
                                            checked={
                                                checkboxFieldValueSelected.some((x: any) => x.indexForValue === item.indexForValue)
                                                // || id && item.value !== null && item.templateValue !== null && item.value === item.templateValue 
                                            }
                                            disabled={fieldclaimCodeAll}
                                            testId={"checkbox-indexofValue"}
                                            onSelectionChangeHandler={(check: boolean) => handleCheckBoxValue(check, id ? item.templateValue : item.value, item.indexForValue)}
                                        />
                                    </Typography>
                                )}
                            <Typography
                                component="span"
                                sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", }}
                            >
                                {item.detail}
                            </Typography>

                        </Box>

                    </Grid>
                    <Grid size={{ xs: .08, sm: .08, md: .08, lg: .08, xl: .08 }}></Grid>
                    <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }} sx={{
                        justifyContent: "end", display: "flex",
                        "& .numberFieldWrapper": {
                            marginBottom: "0!important",
                            width: "100%"
                        },
                    }}>
                        <RHookFormNumberField
                            id={`tD1FieldId_${item.indexForValue}`}
                            // placeholder=""
                            testId="item-indexofValue"
                            // readOnly={id && item.value !== null && item.value === item.templateValue !== null && item.templateValue ? true : fieldclaimCodeAll || item.indexForValue === 1}
                            readOnly={
                                // id && item.value !== null && item.templateValue !== null && item.value === item.templateValue ||
                                fieldclaimCodeAll
                                || (item.indexForValue === 1 && selectedTD1EmployeeDataByIddetails && !selectedTD1EmployeeDataByIddetails.editable)
                                || (item.indexForValue === 1 && existingRecordData && !existingRecordData[0]?.editable)
                                || item.heading === "Disability amount" || checkboxFieldValueSelected.some((x: any) => x.indexForValue === item.indexForValue)
                            }

                            // fieldValue={fieldclaimCodeAll ? 0 : item.indexForValue === 1 ? item.value :
                            //     checkboxFieldValueSelected.find(
                            //         (x: any) => x.indexForValue === item.indexForValue
                            //     )?.value ? checkboxFieldValueSelected.find(
                            //         (x: any) => x.indexForValue === item.indexForValue
                            //     )?.value :
                            //         id ? item.value : null
                            // }
                            fieldValue={
                                fieldclaimCodeAll
                                    ? 0
                                    : item.indexForValue === 1 && item.value && item.value !== 0
                                        ? item.value :
                                        (item.indexForValue === 1 && id && item.value === 0) || (item.indexForValue === 1 && id && !item.value)
                                            ? item.templateValue
                                            : checkboxFieldValueSelected.find(
                                                (x: any) => x.indexForValue === item.indexForValue
                                            )?.value !== undefined
                                                ? item.templateValue
                                                : formMethods.getValues(`tD1FieldId_${item.indexForValue}`) === 0
                                                    ? 0
                                                    : id
                                                        ? item.value
                                                        : null
                            }

                        />
                    </Grid>
                </Grid>
            ))}

            {totalClaimAmountData && <Grid
                container
                sx={{
                    marginBottom: "1.5rem",
                }}
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            >
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "start" }} >

                        <Grid size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}>
                            <Box sx={{ flex: 1, flexWrap: "" }}>
                                <Typography
                                    component="span"
                                    sx={{
                                        fontWeight: "bold", fontSize: ".875rem",
                                    }}
                                >
                                    {`${totalClaimAmountData.heading} - `}

                                </Typography>
                                <Typography
                                    component="span"
                                    sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", }}
                                >
                                    {totalClaimAmountData.detail}
                                </Typography>

                            </Box>

                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
                            <Box
                                sx={{
                                    fontWeight: "bold",
                                    textAlign: "end",
                                    paddingRight: "14px",
                                    color: "#4b5563",
                                    fontFamily: '"Inter var", sans-serif'
                                }}
                            >
                                {
                                    fieldclaimCodeAll ? "0.00" :
                                        !fieldclaimCodeAll && id && Number(totalClaimAmount) !== 0 ? formatAmountCommaSeperator(totalClaimAmount) :
                                            updatedfederalFormDataWithoutTotalClaimAmount[0].value && updatedfederalFormDataWithoutTotalClaimAmount[0].value !== 0 ?
                                                formatAmountCommaSeperator(updatedfederalFormDataWithoutTotalClaimAmount[0].value) :
                                                formatAmountCommaSeperator(updatedfederalFormDataWithoutTotalClaimAmount[0].templateValue)}
                            </Box>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>}


            {td1FormSlug === "federal" &&
                <>
                    <hr />
                    <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ marginBottom: "1rem" }}>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: ".875rem", marginBottom: "1rem" }}>
                                Deduction for Living in a Prescribed Zone
                            </Typography>
                            <Typography sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", marginBottom: "1rem" }}>
                                If you live in the Northwest Territories, Nunavut, Yukon, or another prescribed northern zone for more than six months in a row beginning or ending in , you can claim:
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            columnSpacing={6}
                            sx={{
                                alignItems: "center",
                                marginBottom: "1rem",
                                "& .calenderWrapper": { marginBottom: "0!important" },
                                "& .MuiGrid-root ": { marginBottom: "0px!important" },
                            }}>
                            <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                                <RHookFormDatePicker
                                    name="dateFrom"
                                    testId="date-from"
                                    label="Date From"
                                    labelPosition={LabelPosition.Left}
                                    format="M dd, yy"
                                // onDateSelectionChangeHandler={(value: any) => handlePrescribedZoneFieldChange("startDate", value)}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                                <RHookFormDatePicker
                                    name="dateTo"
                                    testId="date-to"
                                    label="Date To"
                                    labelPosition={LabelPosition.Left}
                                    format="M dd, yy"
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                <Typography sx={{ fontWeight: "bold", fontSize: ".875rem", textAlign: "end" }}>
                                    {`Total Days: ${totalDays}`}
                                </Typography>
                                <Typography sx={{ fontWeight: "bold", fontSize: ".875rem", textAlign: "end" }}>
                                    {`Total Amount: ${totalAmount}`}
                                </Typography>
                            </Grid>

                        </Grid>

                        <Grid
                            container
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            sx={{ marginBottom: "1rem" }}
                        >
                            <Grid
                                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                                sx={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}
                            >
                                <EnhancedButtonPrimeReact
                                    label="Reset"
                                    raised
                                    severity={EnhancedButtonPrimeReactSeverity.Secondary}
                                    onClickHandler={onResetDeductionPanelClicked}
                                />
                                <EnhancedButtonPrimeReact
                                    label="Refresh"
                                    raised
                                    severity={EnhancedButtonPrimeReactSeverity.Secondary}
                                    onClickHandler={onRefreshDeductionPanelClicked}
                                />
                            </Grid>
                        </Grid>


                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            sx={{ "& .MuiFormControlLabel-root .MuiTypography-root": { fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }, }}>
                            <EnhancedRadioGroupRHF
                                name="amountForEachDay"
                                testId="amount-for-each-day"
                                options={[
                                    { label: "$11.00 for each day that you live in the prescribed northern zone, or", value: 11 },
                                    { label: "$22.00 for each day that you live in the prescribed northern zone if, during that time, you live in a dwelling that you maintain, and you are the only person living in that dwelling who is claiming this deduction.", value: 22 },
                                ]}
                            // selectedValue={11}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            sx={{
                                "& .MuiFormControlLabel-root": { marginBottom: "0!important", color: "rgba(0, 0, 0, 0.6)" },
                                "& .MuiFormControlLabel-root .MuiTypography-root": { fontSize: ".875rem" },
                            }}
                        >
                            <EnhancedCheckboxRHF
                                name="prescribedZonesEmployee"
                                testId="prescribed_zones_employee"
                                checked={false}
                                checkboxLabel="Employees living in a prescribed intermediate zone can claim 50% of the total of the above amounts. For more information, get Form T2222, Northern Residents Deductions, and the Publication T4039, Northern Residents Deductions – Places in Prescribed Zones."
                            />
                        </Grid>


                        <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ marginTop: "1rem" }}>
                            <Grid size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography component="span" sx={{ fontWeight: "bold", fontSize: ".875rem" }}>
                                        {"Additional Tax to be Deducted - "}
                                    </Typography>
                                    <Typography component="span" sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}>
                                        You may want to have more tax deducted from each payment, especially if you receive other income, including non-employment income such as CPP or QPP benefits, or Old Age Security pension. By doing this, you may not have to pay as much tax when you file your income tax return. To choose this option, state the amount of additional tax you want to have deducted from each payment. To change this deduction later, complete a new Form TD1.
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }} sx={{
                                justifyContent: "end", display: "flex",
                                "& .numberFieldWrapper": { marginBottom: "0!important", width: "100%" },
                            }}>
                                <RHookFormNumberField
                                    id="additionalTaxToBeDeducted"
                                    testId="additional-tax-to-be-deducted"
                                />
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }} sx={{ marginTop: "1rem" }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography component="span" sx={{ fontWeight: "bold", fontSize: ".875rem" }}>
                                    {"Reduction in tax deductions - "}
                                </Typography>
                                <Typography component="span" sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}>
                                    You can ask to have less tax deducted if on your income tax return you are eligible for deductions or non-refundable tax credits that are not listed on this form (for example, periodic contributions to a Registered Retirement Savings Plan (RRSP), child care or employment expenses, and charitable donations). To make this request, complete Form T1213, Request to Reduce Tax Deductions at Source, to get a letter of authority from your tax services office. Give the letter of authority to your employer or payer. You do not need a letter of authority if your employer deducts RRSP contributions from your salary.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </>
            }


        </>
    );
};